import React, { useState } from 'react';

const CircleAvatar = ({ src, alt }) => (
  <div className="h-12 w-12 rounded-full overflow-hidden ring-2 ring-[#81be00]/20 shadow">
    <img src={src} alt={alt} className="h-full w-full object-cover" />
  </div>
);

const PersonCard = ({ person }) => (
  <div className="flex items-center gap-3 rounded-lg border border-stone-200 bg-white px-3 py-2 text-stone-800 shadow">
    <CircleAvatar src={person.image} alt={person.name} />
    <div>
      <div className="font-medium title-font text-stone-900">{person.name}</div>
      <div className="text-xs text-[#81be00] font-medium">{person.role}</div>
    </div>
  </div>
);

const Toggle = ({ open, onClick, label }) => (
  <button
    onClick={onClick}
    className="inline-flex items-center gap-2 text-left select-none"
    aria-expanded={open}
  >
    <span
      className={[
        'grid h-6 w-6 place-items-center rounded-md border transition-colors',
        open ? 'bg-[#81be00] border-[#81be00] text-white' : 'border-stone-300 text-stone-500'
      ].join(' ')}
    >
      {open ? '-' : '+'}
    </span>
    <span className="text-stone-800 font-medium">{label}</span>
  </button>
);

const TreeNode = ({ node, depth = 0 }) => {
  const hasChildren = Array.isArray(node.children) && node.children.length > 0;
  const [open, setOpen] = useState(depth === 0); // only root open by default

  return (
    <div className="relative">
      <div className="pl-4 md:pl-6">
        {node.person ? (
          <PersonCard person={node.person} />
        ) : (
          <Toggle open={open} onClick={() => setOpen(!open)} label={node.title} />
        )}
      </div>

      {hasChildren && open && (
        <div className="ml-6 md:ml-8 border-l-2 border-stone-300 pl-4 md:pl-6 mt-3 space-y-3">
          {node.children.map((child, idx) => (
            <TreeNode key={idx} node={child} depth={depth + 1} />
          ))}
        </div>
      )}
    </div>
  );
};

const TeamTree = ({ data }) => {
  return (
    <div className="rounded-2xl border border-stone-200 bg-stone-50 px-4 py-6 md:px-8 md:py-10 text-stone-900 shadow-sm">
      <div className="mb-6">
        <h3 className="text-2xl md:text-3xl font-light title-font">
          <span className="bg-gradient-to-br from-[#81be00] to-[#a6d94a] bg-clip-text text-transparent">Organization Tree</span>
        </h3>
        <p className="mt-2 text-stone-600 text-sm md:text-base">Board leadership and team structure at a glance.</p>
      </div>
      <TreeNode node={data} />
    </div>
  );
};

export default TeamTree;
